import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchStory = (id) => HttpClient().get(`/stories/v2/${id}`)

const getStoryV2 = (id) => (dispatch) =>
  fetchStory(id)
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getStoryV2
